/** Gerado por scripts/generate-build-meta.mjs — não editar manualmente */
export const APP_BUILD_META = {"buildId":"nogit-20260816T211739","builtAt":"2026-08-16T21:17:39.097Z","gitSha":"nogit"} as const;
